export function normalizeSubscriptionText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

export function isPaidPurchase(purchase) {
  const status = normalizeSubscriptionText(
    purchase?.statut_reglement,
  );

  const stripeStatus = normalizeSubscriptionText(
    purchase?.payment_status,
  );

  return status === "regle" || stripeStatus === "paid";
}

export function addOneYear(dateValue) {
  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const expiryDate = new Date(date);
  expiryDate.setFullYear(expiryDate.getFullYear() + 1);

  return expiryDate;
}

export function getPurchaseExpiryDate(purchase) {
  if (purchase?.date_echeance) {
    const explicitExpiryDate = new Date(
      purchase.date_echeance,
    );

    if (!Number.isNaN(explicitExpiryDate.getTime())) {
      return explicitExpiryDate;
    }
  }

  return addOneYear(purchase?.date_achat);
}

export function getSubscriptionProgress(purchase) {
  const startDate = new Date(purchase?.date_achat);
  const expiryDate = getPurchaseExpiryDate(purchase);

  if (
    Number.isNaN(startDate.getTime()) ||
    !expiryDate
  ) {
    return {
      status: "unknown",
      label: "Échéance inconnue",
      tone: "slate",
      progress: 0,
      daysLeft: null,
      startDate: null,
      expiryDate: null,
      canRenew: false,
    };
  }

  const now = new Date();

  const totalDuration =
    expiryDate.getTime() - startDate.getTime();

  const elapsedDuration =
    now.getTime() - startDate.getTime();

  const rawProgress =
    totalDuration > 0
      ? Math.round(
          (elapsedDuration / totalDuration) * 100,
        )
      : 100;

  const progress = Math.max(
    0,
    Math.min(100, rawProgress),
  );

  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const daysLeft = Math.ceil(
    (expiryDate.getTime() - now.getTime()) /
      millisecondsPerDay,
  );

  if (daysLeft < 0) {
    return {
      status: "expired",
      label: "Abonnement expiré",
      tone: "rose",
      progress: 100,
      daysLeft,
      startDate,
      expiryDate,
      canRenew: true,
    };
  }

  if (daysLeft <= 30) {
    return {
      status: "renew",
      label: "À renouveler",
      tone: "amber",
      progress,
      daysLeft,
      startDate,
      expiryDate,
      canRenew: true,
    };
  }

  return {
    status: "active",
    label: "Abonnement actif",
    tone: "emerald",
    progress,
    daysLeft,
    startDate,
    expiryDate,
    canRenew: false,
  };
}

export function getLatestPaidPurchase(purchases = []) {
  return (
    [...purchases]
      .filter(isPaidPurchase)
      .sort(
        (first, second) =>
          new Date(second.date_achat).getTime() -
          new Date(first.date_achat).getTime(),
      )[0] || null
  );
}

export function formatSubscriptionDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}